export default __webpack_public_path__ + "img/7712d1c7a42631dbc489cd80a64241a0.png";